module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.c457ed9d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Medium/Rubik-Medium.eot
// module id = 1304
// module chunks = 49